// extracted by mini-css-extract-plugin
module.exports = {"errorCardBody":"ErrorBox-3aa9c095b327c5a3"};